import { Route } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import ProtectedRouteV2 from "./ProtectedRouteV2";
import FeatureProtectedRoute from "./FeatureProtectedRoute";
import { SYSTEM_FEATURE } from "../types/system/features";

// Pages
import SupplierBalancesPage from "../pages/AccountsPayable/SupplierBalancesPage";
import RegisterPaymentPage from "../pages/AccountsPayable/RegisterPaymentPage";
import PaymentHistoryPage from "../pages/AccountsPayable/PaymentHistoryPage";
import UpcomingDuePage from "../pages/AccountsPayable/UpcomingDuePage";
import OverduePage from "../pages/AccountsPayable/OverduePage";
import AgingReportPage from "../pages/AccountsPayable/AgingReportPage";

const accountsPayableRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route element={<FeatureProtectedRoute feature={SYSTEM_FEATURE.ACCOUNTS_PAYABLE} />}>

    {/* 📌 Proveedores con deuda */}
    <Route
      path="/finance/cxp/supplier-balances"
      element={
        <>
          <PageTitle title="Proveedores con Deuda | Codenova POS" />
          <SupplierBalancesPage />
        </>
      }
    />

    {/* 💳 Registrar Pago */}
    <Route
      path="/finance/cxp/register-payment/:payableId?"
      element={
        <>
          <PageTitle title="Registrar Pago | Codenova POS" />
          <RegisterPaymentPage />
        </>
      }
    />

    {/* 📜 Historial de pagos */}
    <Route
      path="/finance/cxp/payment-history/:payableId?"
      element={
        <>
          <PageTitle title="Historial de Pagos | Codenova POS" />
          <PaymentHistoryPage />
        </>
      }
    />

    {/* ⏳ Próximos a vencer */}
    <Route
      path="/finance/cxp/upcoming-due"
      element={
        <>
          <PageTitle title="Próximos a Vencer | Codenova POS" />
          <UpcomingDuePage />
        </>
      }
    />

    {/* ❌ Vencidos */}
    <Route
      path="/finance/cxp/overdue"
      element={
        <>
          <PageTitle title="Cuentas Vencidas | Codenova POS" />
          <OverduePage />
        </>
      }
    />

    {/* 📊 Aging report */}
    <Route
      path="/finance/cxp/aging"
      element={
        <>
          <PageTitle title="Reporte Aging | Codenova POS" />
          <AgingReportPage />
        </>
      }
    />

    </Route>
  </Route>
);

export default accountsPayableRoutes;
